import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col, Alert } from 'react-bootstrap';

import { parseQs } from 'helpers/http';

import { DOMAIN, BASENAME } from 'js/constants';

class DashboardStripeOnboarding extends React.Component {
  getState = () => {
    const { appIntl, projectConfig, user } = this.props;

    return {
      whiteLabelProjectId: projectConfig.data.id,
      username: user.username,
      route: appIntl.urlPrefix + 'account',
    };
  };

  getErrorMessage = () => {
    const {
      intl: { messages },
      location,
    } = this.props;

    const query = parseQs(location.search);

    if (query.stripe_error) {
      return (
        <Alert bsStyle="warning">
          <h4>{messages.stripe_error}</h4>
          <p className="no-margin">
            <FormattedMessage
              id="stripe_connect_error_with_type"
              values={{
                type: <b>{query.stripe_error}</b>,
              }}
            />
          </p>
        </Alert>
      );
    }
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      projectConfig,
    } = this.props;

    const state = window.btoa(JSON.stringify(this.getState()));

    return (
      <div className="jumbotron">
        <Grid fluid className="m-b-20 m-t-20">
          <Row>
            <Col lg={6} className="bg-white">
              <div className="padding-30 text-center">Nice video here</div>
            </Col>
            <Col lg={6}>
              <div className="card card-transparent">
                <div className="card-header">
                  {this.getErrorMessage()}
                  <div className="card-title">{messages.e_payments}</div>
                </div>
                <div className="card-block">
                  <h3>{messages.stripe_connect}</h3>
                  <p>{messages.we_will_handle_epayments_for_you}</p>
                  <div className="text-right p-t-15">
                    <a
                      className="btn btn-primary m-l-10 m-t-10"
                      href={
                        'https://connect.stripe.com/oauth/authorize?scope=read_write&redirect_uri=' +
                        DOMAIN +
                        BASENAME +
                        appIntl.urlPrefix +
                        'stripe/callback&response_type=code&client_id=' +
                        projectConfig.data.stripe_client_id +
                        '&state=' +
                        state
                      }
                    >
                      <i className="fab fa-stripe-s m-r-5" /> {messages.connect_with_stripe}
                    </a>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    projectConfig: state.data.projectConfig,
    user: state.login.user,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(DashboardStripeOnboarding)));
